import { AUTH_LOGIN } from 'portal/constants/Routes';
import { configureStore } from '@reduxjs/toolkit';
import { ctaContainerStyles, linkButtonStyles } from 'auth/AuthStyles';
import { Provider } from 'react-redux';
import AuthLayout from 'auth/AuthLayout';
import LinkButton from '@opploans/link-button-component/LinkButton';
import PasswordEditAndConfirm from 'components/component_lib/PasswordEditAndConfirm';
import React from 'react';
import reducer from 'reducers/reducer';

const store = configureStore({
  reducer,
  preloadedState: {
    errors: {},
    isDisabled: {},
    email: window.AppConfigState?.password_reset?.email || '',
    password: '',
    passwordConfirmation: '',
    additionalProps: {},
    passwordResetToken: new URLSearchParams(window.location.search).get(
      'reset_password_token'
    )
  }
});

function AuthPasswordEdit({ navigate }) {
  return (
    <AuthLayout
      title='Change Your Password'
      subTitle='Your new password must not be your most recently used password.'
      subHeaderStyles={{ textAlign: 'center' }}
    >
      <Provider store={store}>
        <PasswordEditAndConfirm navigate={navigate} />
      </Provider>
      <div css={ctaContainerStyles}>
        <LinkButton
          lightBackground
          additionalStyle={linkButtonStyles}
          onClick={() => navigate(AUTH_LOGIN)}
        >
          Return to Login
        </LinkButton>
      </div>
    </AuthLayout>
  );
}

export default AuthPasswordEdit;
